class AppoinmentCreateService {
    constructor(DoclrModalService,
                notificationService,
                $state,
                slicesService,
                $rootScope) {
        'ngInject';

        this.DoclrModalService = DoclrModalService;
        this.notificationService = notificationService;
        this.$state = $state;
        this.slicesService = slicesService;
        this.$rootScope = $rootScope;
    }

    createAppointment(appointment, calendar) {
        calendar.maakNieuweAfspraak(false, appointment)
            .then(response => this.afterSave(response, appointment, calendar, true))
            .catch(error => this._handleError(error, appointment, calendar));
    }

    _handleError(error, appointment, calendar) {
        if (error && error.data && error.data.error === 'create.appointment.conflict') {
            this.DoclrModalService.openConfirmModal(
                "Afspraak overlapt met een andere afspraak.",
                "Deze afspraak overlapt met een bestaande afspraak. Wil je toch doorgaan?"
            )
                .then(() => {
                    calendar.maakNieuweAfspraak(true, appointment)
                        .then(response => this.afterSave(response, appointment, calendar, true))
                        .catch(angular.noop);
                })
                .catch(angular.noop);
        }
    }

    afterSave(response, appointment, calendar, isNew) {
        let afspraakNaBewaren = response.data;

        let actie = isNew ? 'gemaakt' : 'gewijzigd';
        this.$rootScope.$emit('afspraak.gewijzigd', 'afspraak ' + actie, afspraakNaBewaren);

        this.notificationService.showSuccess(
            'Afspraak ' + actie +
            ' voor ' + (afspraakNaBewaren.voornaam ? afspraakNaBewaren.voornaam + ' ' : '') +
            afspraakNaBewaren.naam + ' bij ' + calendar.naam +
            ' op ' + moment(afspraakNaBewaren.dag).format('YYYY-MM-DD') + ' van ' + afspraakNaBewaren.van + 'u tot ' + afspraakNaBewaren.tot + 'u',
            {delay: 20000}
        );

        this.$state.go('^')
            .then(() => this.slicesService.slicesLoader.navigator.wijzigDagEnAgenda(appointment.dag, calendar.id, response.headers('Location')));

    }
}

(function () {
    'use strict';

    angular.module('doclr.components.adminagendacomponents')
        .service('AppoinmentCreateService', AppoinmentCreateService)
})();
